var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('game-items-add',{attrs:{"game-item-variant":"characters"},on:{"added":_vm.redirectToEditPage},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(_vm._s(_vm.$t('characters.add')))]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }